import clsx from 'clsx';
import { isNull } from 'lodash';
import { array } from 'prop-types';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { MultiActionButton, SanitizedHtml, StrapiImg } from 'components';
import { getModalContent } from 'helpers';
import { useClickOutside, useSafeState } from 'hooks';

import 'assets/styles/components/base/content-display/drawer.scss';

const PartnerList = ({ partners }) => {
  const { t } = useTranslation();
  const [drawerIndex, setDrawerIndex] = useSafeState(null);
  const partnerItem = useRef();

  useClickOutside(
    partnerItem,
    (event) => {
      const isTriggerCta = event.target?.classList?.contains('trigger-cta');
      !isNull(drawerIndex) && !isTriggerCta && setDrawerIndex(null);
    },
    [drawerIndex]
  );

  return (
    <>
      {partners.map((partner, index) => (
        <div
          className={clsx('partner-card relative', index + 1 !== partners.length && 'with-border')}
          key={`partner-item-${partner.id}`}
          ref={partnerItem}
        >
          <button
            type="button"
            className="trigger-cta absolute inset-0 opacity-0 lg:hidden"
            onClick={() => setDrawerIndex(index)}
          >
            {t('buttons.seeActions')}
          </button>

          <div className="w-1/3 md:w-48 lg:rounded-xl lg:self-center lg:overflow-hidden lg:h-[13.75rem] lg:w-[22.5rem]">
            <StrapiImg image={partner.image} className="h-full w-full object-cover" />
          </div>

          <div className="py-5 pr-3 w-2/3 lg:flex lg:gap-2 lg:justify-between">
            <div className="lg:w-3/5">
              <h3 className="h2 underlined-yellow mb-4 text-base lg:text-2xl">
                <span className="truncate-line two-lines">{partner.title}</span>
              </h3>

              <SanitizedHtml
                content={partner?.content}
                className="text-sm truncate-line four-lines lg:mb-4 lg:text-base lg:block"
              />
            </div>

            <div className={clsx('drawer-blur', drawerIndex === index ? 'open' : 'closed')}>
              {partner.cta.map((cta, i) => (
                <MultiActionButton
                  cta={cta}
                  index={i}
                  modalContent={() => getModalContent(partner, i)}
                  key={`cta-action-${i}`}
                />
              ))}
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

PartnerList.propTypes = {
  partners: array.isRequired
};

export default PartnerList;
